import React, { useState } from 'react';
import { back, chevron_right, gear } from '../../Images/Icons';
import { useNavigate } from 'react-router-dom';
import { View } from '../../Components';
import css from './AlarmPage.module.scss';
import { warning } from '../../Images/Icons';

const AlarmPage = () => {
    const navigation = useNavigate();
    const onGoback = () => {
        navigation(-1);
    }
    const renderDonut = (critical, major, minor, warning) => {
        const total = critical + major + minor + warning;
        const criticalDeg = (360 * (critical / total));
        const majorDeg = (360 * (major / total));
        const minorDeg = (360 * (minor / total));
        const warningDeg = (360 * (warning / total));


        return (<div style={{ width: 100, height: 100, position: "relative", border: 'solid 0px #dedede', borderRadius: '50%' }}>
            {/* { Critical } */}
            <div style={{ width: '100%', height: '100%', position: 'absolute', clip: 'rect(0px, 100px, 100px, 50px)', transform: 'rotate(0deg)' }}>
                <div style={{ width: '100%', height: '100%', clip: 'rect(0px, 50px, 100px, 0px)', position: 'absolute', borderRadius: '50%', background: '#F62C42', transform: `rotate(${criticalDeg}deg)` }}></div>
            </div>
            {/* { Major } */}
            <div style={{ width: '100%', height: '100%', position: 'absolute', clip: 'rect(0px, 100px, 100px, 50px)', transform: `rotate(${criticalDeg}deg)` }}>
                <div style={{ width: '100%', height: '100%', clip: 'rect(0px, 50px, 100px, 0px)', position: 'absolute', borderRadius: '50%', background: '#FF8438', transform: `rotate(${majorDeg}deg)` }}></div>
            </div>
            {/* { Minor } */}
            <div style={{ width: '100%', height: '100%', position: 'absolute', clip: 'rect(0px, 100px, 100px, 50px)', transform: `rotate(${(criticalDeg + majorDeg)}deg)` }}>
                <div style={{ width: '100%', height: '100%', clip: 'rect(0px, 50px, 100px, 0px)', position: 'absolute', borderRadius: '50%', background: '#FDD020', transform: `rotate(${minorDeg}deg)` }}></div>
            </div>
            {/* { Warning } */}
            <div style={{ width: '100%', height: '100%', position: 'absolute', clip: 'rect(0px, 100px, 100px, 50px)', transform: `rotate(${(criticalDeg + majorDeg + minorDeg)}deg)` }}>
                <div style={{ width: '100%', height: '100%', clip: 'rect(0px, 50px, 100px, 0px)', position: 'absolute', borderRadius: '50%', background: '#69aff4', transform: `rotate(${warningDeg}deg)` }}></div>
            </div>
            <div style={{
                width: 80, height: 80, position: 'absolute', background: '#F2F5FA', top: 0, right: 0, bottom: 0, left: 0, borderRadius: '50%', margin: 'auto',
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontSize: 10, fontWeight: 400, color: '#79808F'
            }}>
                <div style={{ fontSize: 18, fontWeight: 500, color: '#292929' }}>6</div>
                Total Alarms
            </div>
        </div>);
    }

    return (
        <div style={{}}>
            <div class="mainHeader" style={{  display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', }}>
                <div style={{ display: 'flex', margin: '0 20px' }}>
                    <div onClick={onGoback} style={{
                        display: 'flex', justifyContent: 'center', cursor: 'pointer',
                        alignItems: 'center', width: 32, height: 32, background: 'white', borderRadius: 16
                    }}>
                        <img src={back} alt="" style={{ width: 28, height: 28 }} />
                    </div>
                    <div style={{ fontSize: 18, fontWeight: 500, color: 'white', marginLeft: 12 }}>Alarms</div>
                </div>
            </div>
            <div className="page-content" style={{ display: 'flex', flexDirection: 'column', background: '#F2F5FA' }}>
                <div style={{  marginTop: 0, padding: 18, background: 'white', borderRadius: 0 }}>
                    <div style={{ height: 94, width: '100%', display: 'flex', justifyContent: 'space-evenly', position: 'relative' }}>
                        <div style={{ flex: 3, width: '100%', display: 'flex', justifyContent: 'center' }}>
                            {renderDonut(0, 0, 0, 0)}
                        </div>
                        <div style={{ flex: 2, border: 'none 1px' }}>
                            <div style={{ fontSize: 14, fontWeight: 600, color: '#1A202C' }}>0</div>
                            <div style={{ height: 24, display: 'flex', alignItems: 'center', fontSize: 14, fontWeight: 400, color: '#6A6A6A' }}>
                                <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#F62C42', marginRight: 6 }}></div> <span>Critical</span>
                            </div>
                            <div style={{ fontSize: 14, fontWeight: 600, color: '#1A202C' }}>0</div>
                            <div style={{ height: 24, display: 'flex', alignItems: 'center', fontSize: 14, fontWeight: 400, color: '#6A6A6A' }}>
                                <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#FDD020', marginRight: 6 }}></div> <span>Minor</span>
                            </div>
                        </div>
                        <div style={{ flex: 2, border: 'none 1px' }}>
                            <div style={{ fontSize: 14, fontWeight: 600, color: '#1A202C' }}>0</div>
                            <div style={{ height: 24, display: 'flex', alignItems: 'center', fontSize: 14, fontWeight: 400, color: '#6A6A6A' }}>
                                <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#FF8438', marginRight: 6 }}></div> <span>Major</span>
                            </div>
                            <div style={{ fontSize: 14, fontWeight: 600, color: '#1A202C' }}>0</div>
                            <div style={{ height: 24, display: 'flex', alignItems: 'center', fontSize: 14, fontWeight: 400, color: '#6A6A6A' }}>
                                <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#69aff4', marginRight: 6 }}></div> <span>Warning</span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div style={{ margin: 20, marginTop:20, padding: 18, background: 'white', borderRadius: 12 }}>
                    <div className={css.title}>
                        <div className={css.warning}><img src={warning}/></div> Grid Loss</div>
                    <div className='row mt-2'>
                        <div className={`col-5 ${css.inv}`}>Device Name</div>
                        <div className={`col-7 ${css.date}`}>INV-102327008674</div>
                    </div>
                    <div className='row'>
                        <div className={`col-5 ${css.inv}`}>Occurrence Time</div>
                        <div className={`col-7 ${css.date}`}>2024-03-23  17:23:51  +07:00</div>
                    </div>
                </div>
                <div style={{ margin: 20, marginTop:-10, padding: 18, background: 'white', borderRadius: 12 }}>
                    <div className={css.title}>
                        <div className={css.warning}><img src={warning}/></div> Abnormal communication</div>
                    <div className='row mt-2'>
                        <div className={`col-5 ${css.inv}`}>Device Name</div>
                        <div className={`col-7 ${css.date}`}>INV-102327008674</div>
                    </div>
                    <div className='row'>
                        <div className={`col-5 ${css.inv}`}>Occurrence Time</div>
                        <div className={`col-7 ${css.date}`}>2024-03-23  17:23:51  +07:00</div>
                    </div>
                </div> */}
                <div style={{position:'absolute', width:'37%', bottom:0}}>
                    <View >
                        <div style={{
                            width: '100%', height: 44, display: 'flex', justifyContent: 'center', marginLeft: 20, marginRight: 20,
                            fontSize: 16, fontWeight: 700, marginBottom: 40, background: '#2DFBB5',
                            alignItems: 'center', color: '#292929', borderRadius: 8, cursor: 'pointer',
                        }}>
                            Contact MODENA Energy Team
                        </div>
                    </View>
                </div>
            </div>
        </div>
    )
}

export default AlarmPage